import { Add as ContentAdd } from "@mui/icons-material";
import { Fab as FloatingActionButton } from "@mui/material";
import type { FC } from "react";

interface Props {
  onClick: () => void;
  label?: string;
}

const AddFab: FC<Props> = ({ onClick, label }) => (
  <FloatingActionButton aria-label={label ?? "nowy"} color="primary" onClick={onClick}>
    <ContentAdd />
  </FloatingActionButton>
);

export default AddFab;
